// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"9":"b8593a39","100":"31aaf125","505":"e6752fb3"}[chunkId] + ".chunk.css";
};